module.exports = __webpack_public_path__ + "img/tjx_5.b8042dc3.png";